var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{class:{ 'required': _vm.required },attrs:{"label":_vm.label,"type":(_vm.hasError() ? 'is-danger': ''),"message":_vm.errorMessage()}},[_c('b-select',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"input":_vm.inputListener}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }